var path = 'scripts/views/components/amount-input-field.html';
var html = "<input class=\"form-control amount-input\"\n       type=\"text\"\n       ng-model=\"$ctrl.numberField\"\n       ng-blur=\"$ctrl.format()\"\n       ng-model-options=\"{getterSetter: true}\">\n";
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, html) }]);
module.exports = path;


//////////////////
// WEBPACK FOOTER
// ./src/main/resources/static/scripts/views/components/amount-input-field.html
// module id = 300
// module chunks = 0